import { render, staticRenderFns } from "./ListChubunrui.vue?vue&type=template&id=66811df4&"
import script from "./ListChubunrui.vue?vue&type=script&lang=ts&"
export * from "./ListChubunrui.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports